import React from 'react';
import FaIcon from '../FaIcon';

// One launcher card (CD-5241 OPS Reports redesign). kind 'report' switches the
// violet accent + "Run report" affordance; everything else is an export card.
// roleKey is consumed by ReportLauncherPage (cards render unconditionally here).
function ReportLauncherCard({ title, description, iconName, fmt, onClick, kind = '', note = '', buttonLabel = '' }) {
  const isReport = kind === 'report';
  const label = buttonLabel || (isReport ? 'Run report' : 'Export');
  return (
    <div className={isReport ? 'rp-card report' : 'rp-card'}>
      <div className='rp-card-top'>
        <div className='rp-ico'>
          <FaIcon iconName={iconName} />
        </div>
        <span className={isReport ? 'rp-fmt report' : 'rp-fmt'}>{fmt}</span>
      </div>
      <h3 className='rp-title'>{title}</h3>
      <p className='rp-desc'>{description}</p>
      {note ? (
        <span className='rp-note'>
          <FaIcon iconName='fa-solid fa-clock' />
          {note}
        </span>
      ) : null}
      <button
        className='btn navy'
        type='button'
        onClick={onClick}
      >
        <FaIcon iconName={isReport ? 'fa-solid fa-play' : 'fa-solid fa-download'} />
        {label}
      </button>
    </div>
  );
}

export default ReportLauncherCard;
